import { UseCustomAxios } from "../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../util/Utils";

export function UseOrdergifts() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    var errorState;

    errorState = {
      // minOrderItems:
      //   state.minOrderItems == 0 ? false : isEmpty(state.minOrderItems),
      // minPayment: state.minPayment == 0 ? false : isEmpty(state.minPayment),
      giftName: isEmpty(state.giftName),
    };

    // if (errorState.minOrderItems == 0 || errorState.minPayment == 0) {
    //   errorState.minOrderItems = false;
    //   errorState.minPayment = false;
    // }

    setter(errorState);
    if (
      // errorState.minOrderItems ||
      // errorState.minPayment ||
      errorState.giftName
    ) {
      enqueueSnackbar("لطفا نام هدیه سفارش را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getOrdergiftsList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_Ordergifts?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getOrdergiftsById = (Id, callback) => {
    MyAxios.get(`Admin_Ordergifts/${Id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateOrdergifts = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_Ordergifts`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("هدیه با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const addOrdergifts = (state, callback) => {
    let newBody = Object.fromEntries(
      Object.entries(state).filter(([_, v]) => v != undefined)
    );
    const data = new FormData();
    data.append("Content", JSON.stringify(newBody));
    MyAxios.post(`Admin_Ordergifts`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("هدیه با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const deleteOrdergifts = (giftID, callback) => {
    const data = new FormData();
    data.append("GiftID", giftID);
    MyAxios.delete(`Admin_Ordergifts`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("هدیه با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const AddCondition = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Ordergifts/AddCondition`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const RemoveCondition = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.delete(`Admin_Ordergifts/RemoveCondition`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    validate,
    getOrdergiftsList,
    addOrdergifts,
    deleteOrdergifts,
    getOrdergiftsById,
    updateOrdergifts,
    AddCondition,
    RemoveCondition,
  };
}
